import {
    Button,
    Card,
    CardActions,
    CardContent,
    Grid,
    Modal,
    TextField,
    Typography
} from "@material-ui/core";
import clsx from "clsx";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { LoadingOverlay } from "../../../components/LoadingOverlay";
import { getMe } from "../../../graphql/auth";
import { WcvLogCodes, WcvLogLevel } from "../../../graphql/logs.datatypes";
import addNote, { AddNoteVars } from "./addNote.api";
import { useStyles } from "./styles";

interface Props {
    type: number;
    type_id: number;
    className?: string;
    onClose: () => void;
}

export const AddNote = (props: Props) => {
    const { className, onClose, type, type_id, ...rest } = props;
    const classes = useStyles();
    const [formState, setFormState] = useState({
        description: ""
    });
    const [sendAddNote, addNoteData] = addNote();
    const { enqueueSnackbar } = useSnackbar();
    const userData = getMe();

    if (userData.loading) return null;

    const handleFieldChange = (
        event: React.ChangeEvent<
            HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
        >
    ) => {
        event.persist();
        setFormState((oldState: any) => ({
            ...oldState,
            [event.target.name]: event.target.value
        }));
    };

    const onSaveClick = () => {
        const sanitisedData: AddNoteVars = {
            data: {
                level: WcvLogLevel.NOTE,
                user_id: userData!.data!.me!.id,
                type,
                type_id,
                code: WcvLogCodes.ADD_NOTE,
                description: formState.description
            }
        };

        sendAddNote({ variables: sanitisedData })
            .then(() => {
                onClose();
                enqueueSnackbar("Note added", { variant: "success" });
            })
            .catch(() => {
                enqueueSnackbar("There was an error creating the Note", {
                    variant: "error"
                });
            });
    };

    return (
        <Modal onClose={onClose} open={true}>
            <Card {...rest} className={clsx(classes.root, className)}>
                <LoadingOverlay loading={addNoteData.loading}>
                    <form>
                        <CardContent>
                            <Typography
                                align="center"
                                gutterBottom
                                variant="h3"
                            >
                                Add Note
                            </Typography>
                            <Grid
                                className={classes.container}
                                container
                                spacing={3}
                            >
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={3}
                                    label="Note"
                                    name="description"
                                    onChange={handleFieldChange}
                                    value={formState.description}
                                    variant="outlined"
                                />
                            </Grid>
                        </CardContent>
                        <CardActions className={classes.actions}>
                            <Button onClick={onClose} variant="contained">
                                Close
                            </Button>
                            <Button
                                className={classes.saveButton}
                                onClick={onSaveClick}
                                variant="contained"
                            >
                                Save
                            </Button>
                        </CardActions>
                    </form>
                </LoadingOverlay>
            </Card>
        </Modal>
    );
};

export default AddNote;
